import { FC } from 'react';
import { ERROR_DESCRIPTION, ERROR_DESCRIPTION2, ERROR_LINK_MESSAGE, ERROR_TITLE } from '../../constants/error';
import styled from 'styled-components';
import { MarginProps, margin, BorderProps, border, ColorProps, color, TypographyProps, typography, PaddingProps, padding } from 'styled-system';
import { HOME_FULL_URL } from '../../constants/urls';
import { ModuleContainerGeneric } from '../shared/ModuleContainerGeneric';
import { theme } from '@bpba/ui-components';
import { ReactNode } from 'react';

export const NotFound: FC = () => {
  return (
    <ModuleContainerGeneric>
      <Title
        color={theme.colors.primary[0]}
        marginTop="12px"
        marginBottom="7px"
        fontWeight={400}
        fontSize={['26px', null, '34px', '36px']}
        lineHeight={['32px', null, '41px', '43px']}
        tabIndex={0}
      >
        {ERROR_TITLE}
      </Title>

      <Divider marginBottom="12px" marginTop="12px" borderBottomColor={theme.colors.primary[0]} borderBottomStyle="solid" borderBottomWidth="1px" />

      <StyledDiv tabIndex={0}>
        <StyledParagraph>{ERROR_DESCRIPTION}</StyledParagraph>
        <br />
        <StyledParagraph>{ERROR_DESCRIPTION2}</StyledParagraph>
      </StyledDiv>

      <StyledParagraph>
        <LinkContainer href={HOME_FULL_URL} text={ERROR_LINK_MESSAGE} />
      </StyledParagraph>
    </ModuleContainerGeneric>
  );
};

type DividerProps = MarginProps & BorderProps;
const Divider = styled.div<DividerProps>(margin, border);

type TitleProps = ColorProps & MarginProps & TypographyProps;
const Title = styled.h1<TitleProps>(color, margin, typography, { width: 'fit-content' });

type StyledLinkProps = TypographyProps & ColorProps & PaddingProps & BorderProps;
const StyledLink = styled.a<StyledLinkProps>(typography, color, padding, border, {
  textDecorationLine: 'none',
});

type LinkContainerProps = {
  href: string;
  text: string;
  id?: string;
};
const LinkContainer = ({ href, id, text }: LinkContainerProps) => {
  return (
    <StyledLink
      href={href}
      id={id}
      fontWeight={700}
      color={theme.colors.secondary[1]}
      paddingBottom="0px"
      borderBottomWidth="1px"
      borderBottomStyle="solid"
      borderBottomColor={theme.colors.secondary[1]}
    >
      {text}
    </StyledLink>
  );
};

type TextContainerProps = TypographyProps & MarginProps;
const TextContainer = styled.p<TextContainerProps>(typography, {
  marginBlockStart: '0px',
  marginBlockEnd: '14px',
});

const StyledParagraph = ({ children }: { children: ReactNode }) => {
  return (
    <TextContainer fontSize={[14, null, 16]} lineHeight={['18px', null, '21px']}>
      {children}
    </TextContainer>
  );
};

const StyledDiv = styled.div({
  width: 'fit-content',
});
